<div class="app-wrapper flex">
  <!-- Sidebar navigation -->
  <div class="main-sidenav" [ngClass]="{'collapsed': !expanded}">
    <!-- Company logo - fixed at top -->
    <div class="company-logo">
      <img src="assets/dashboard-icons/logo.svg" alt="Haulmatic">
      <span *ngIf="expanded">Haulmatic</span>
    </div>
    
    <!-- Sidenav toggle button -->
    <div class="sidenav-toggle" [ngClass]="{'collapsed': !expanded}" (click)="onToggle()">
      <mat-icon>chevron_left</mat-icon>
    </div>
    
    <!-- Scrollable content area -->
    <div class="scrollable-content">
      <!-- Main navigation menu -->
      <ul class="item-list">
        <li class="item" *ngFor="let moduleConfig of navBarModuleConfigs$ | async; let i = index;"
            cdkOverlayOrigin #moduleOrigin="cdkOverlayOrigin"
            (click)="collapseModule(moduleConfig, moduleOrigin)"
            [class.disabled]="moduleConfig?.disabled"
            [class.active]="moduleConfig.title === activeModuleTitle"
            [attr.aria-haspopup]="isScheduleModule(moduleConfig) ? 'dialog' : null"
            [attr.aria-expanded]="isScheduleModule(moduleConfig) ? scheduleChooserOpen : null">
          <div class="item-wrapper" [matTooltip]="!expanded ? moduleConfig.title : ''"
               [matTooltipDisabled]="expanded">
            <img [src]="moduleConfig.iconPath" class="icon-color icon-size" alt="{{moduleConfig.title}}">
            <span class="icon-color full-width icon-label" *ngIf="expanded">{{moduleConfig.title}}</span>
          </div>
        </li>
      </ul>

      <!-- Schedule module chooser: Classic TMS or TMS Platform -->
      <ng-template
        cdkConnectedOverlay
        [cdkConnectedOverlayOrigin]="scheduleChooserOrigin"
        [cdkConnectedOverlayOpen]="scheduleChooserOpen"
        [cdkConnectedOverlayPositions]="scheduleChooserPositions"
        [cdkConnectedOverlayHasBackdrop]="true"
        cdkConnectedOverlayBackdropClass="cdk-overlay-transparent-backdrop"
        cdkConnectedOverlayPanelClass="schedule-chooser-pane"
        (backdropClick)="closeScheduleChooser()"
        (overlayKeydown)="onScheduleChooserKeydown($event)"
        (detach)="closeScheduleChooser()">
        <div class="schedule-chooser" role="dialog" aria-labelledby="schedule-chooser-title" cdkTrapFocus cdkTrapFocusAutoCapture>
          <div class="schedule-chooser-title" id="schedule-chooser-title">Select Schedule Module</div>
          <div class="schedule-chooser-options">
            <button type="button" class="schedule-chooser-option classic" (click)="openScheduleModule('classic')">
              TMS-Classic
            </button>
            <button type="button" class="schedule-chooser-option platform" (click)="openScheduleModule('platform')">
              TMS-Platform <span class="schedule-chooser-new">(new)</span>
            </button>
          </div>
        </div>
      </ng-template>

      <div class="sidenav-divider"></div>
      
      <ul class="item-list">
        <li class="item c-p disabled" routerLink="/notifications" routerLinkActive="active">
          <div class="item-wrapper" [matTooltip]="!expanded ? 'Notifications' : ''" 
               [matTooltipDisabled]="expanded">
            <img src="assets/dashboard-icons/notifications.svg" class="icon-color icon-size" alt="Notifications">
            <span class="icon-color full-width icon-label" *ngIf="expanded">Notifications</span>
          </div>
        </li>
        
        <li class="item c-p disabled" routerLink="/settings" routerLinkActive="active">
          <div class="item-wrapper" [matTooltip]="!expanded ? 'Settings' : ''" 
               [matTooltipDisabled]="expanded">
            <img src="assets/dashboard-icons/settings.svg" class="icon-color icon-size" alt="Settings">
            <span class="icon-color full-width icon-label" *ngIf="expanded">Settings</span>
          </div>
        </li>
        
        <li class="item c-p disabled" routerLink="/support" routerLinkActive="active">
          <div class="item-wrapper" [matTooltip]="!expanded ? 'Support' : ''" 
               [matTooltipDisabled]="expanded">
            <img src="assets/dashboard-icons/support.svg" class="icon-color icon-size" alt="Support">
            <span class="icon-color full-width icon-label" *ngIf="expanded">Support</span>
          </div>
        </li>
      </ul>
    </div>
    
    <!-- User profile section - fixed at bottom -->
    <div class="user-profile" *ngIf="expanded">
      <div class="avatar">
        <img [src]="(orgUserPhotoUrl$ | async) || 'assets/icons/user.svg'" alt="User">
      </div>
      <div class="user-info">
        <p class="welcome">Welcome back 👋</p>
        <p class="name">{{(user | async)?.firstName}} {{(user | async)?.lastName}}</p>
      </div>
      <mat-icon class="arrow" [matMenuTriggerFor]="userMenu">chevron_right</mat-icon>
    </div>
    <div class="collapsed-user-profile" *ngIf="!expanded">
      <div class="avatar" [matMenuTriggerFor]="userMenu">
        <img [src]="(orgUserPhotoUrl$ | async) || 'assets/icons/user.svg'" alt="User">
      </div>
    </div>

    <!-- User Menu -->
    <mat-menu #userMenu="matMenu" class="user-menu" panelClass="user-menu" (menuOpened)="onMenuOpened()">
      <button mat-menu-item>
        <mat-icon>settings</mat-icon>
        <span>Settings</span>
      </button>
      <button mat-menu-item>
        <mat-icon>security</mat-icon>
        <span>Privacy</span>
      </button>
      <mat-divider></mat-divider>
      <button mat-menu-item (click)="onLogout()">
        <mat-icon>logout</mat-icon>
        <span>Logout</span>
      </button>
    </mat-menu>
  </div>

  <!-- Main content area -->
  <div class="right-content">
    <div class="app-header">
      <hmt-header (toggle)="onToggle()"></hmt-header>
    </div>
    <div class="app-content">
      <router-outlet></router-outlet>
    </div>
  </div>

  <app-agent-bubble *ngIf="('viewAgent' | authorize)"></app-agent-bubble>
  <!-- Supply Chain Brain dock hidden for now
  <app-brain-dock *ngIf="('viewAgent' | authorize) && isControlTowerRoute"></app-brain-dock>
  -->
</div>

